import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { apiGetById } from '../../services/genesisApi/httpsMethods';
import type { FC } from 'react';
import type { LoanComp } from '../../types/deal';
import { SimpleToolbar } from '../../components/layout/Toolbar';
import { CustomButton } from '../../components/common/customButton';
import LoanCompDetail from './LoanComp';


interface LoanCompWrapperProps {
  id?: number;
}

const LoanCompWrapper: FC<LoanCompWrapperProps> = ({ id }) => {
  const navigate = useNavigate();
  const params = useParams<{ loanCompId?: string }>();
  const loanCompId = id ?? (params.loanCompId ? parseInt(params.loanCompId) : undefined);

  const [loanComp, setLoanComp] = useState<LoanComp | null>(null);

  useEffect(() => {
    if (!loanCompId) return;

    apiGetById('loan-comp', loanCompId)
      .then((data) => {
        setLoanComp(data.data[0]);
      })
      .catch((err) => {
        console.error('Failed to fetch loan comp', err);
      });
  }, [loanCompId]);

  if (!loanCompId) return <Typography>Loan Comp ID not found.</Typography>;
  if (!loanComp) return <Typography>No Loan Comp found.</Typography>;

  return (
    <Box sx={{ position: 'relative', zIndex: 1 }}>
      <Box
        sx={{
          position: 'sticky',
          zIndex: 10,
        }}
      >
        <SimpleToolbar>
          <CustomButton
            handleButtonPress={() => { navigate(`/loan-comps/${loanCompId}/edit`); }}
            isButtonDisabled={false}
            text="Edit Loan Comp"
            isLoading={false}
            isLoadingText="Loading"
            solid={false}
            widthOverride="100px"
            data-position="right"
          />
        </SimpleToolbar>
      </Box>
      <Box sx={{ padding: 2, marginBottom: 100, zIndex: 100 }}>
        <LoanCompDetail loanCompId={loanCompId} isEdit={true} />
      </Box>
    </Box>
  );
};

export default LoanCompWrapper;
